import { DataContextProvider, useDataContext } from "../../page/context"
import { FC, useEffect } from "react"
import { FetchStatus, IEntity } from "../../../base/types"

import { useReadAttributes } from "../../../base/hooks"

interface IEventDataProviderProps {
    entity?: string
    data?: IEntity
    children?: React.ReactNode
}

export const EventDataProvider: FC<IEventDataProviderProps> = ({
    entity, data, children
}) => {
    return <>
        <DataContextProvider>
            <EventDataProducer data={data || {}} entity={entity} />
            {children}
        </DataContextProvider>
    </>
}

const EventDataProducer = ({ data, entity }: { data: IEntity, entity?: string }) => {
    const { setDataSource, setData } = useDataContext()
    const { readAttributes } = useReadAttributes();

    useEffect(() => {
        setData({ status: FetchStatus.Loading, type: "Card", result: {} })
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setData({ status: FetchStatus.Success, type: "Card", result: data })
        // eslint-disable-next-line
    }, [data])

    useEffect(() => {
        if (!entity) return;

        readAttributes(entity)
            .then(attributes => setDataSource({ entity, attributes }))
        // eslint-disable-next-line
    }, [entity])

    return <></>
}